import { Select, Space } from 'antd';
import styled, { css } from 'styled-components';
import { CombinationValueType, PointerIcon, CustomCss, DimensionTitleType } from './alertConfig.types';

export const BackBtn = styled.span`
  display: flex;
  align-items: center;
  margin: 17px 23px 14px;
  column-gap: 6px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #818181;
  cursor: pointer;
`;

export const ConfigWrapper = styled.div`
  padding: 0 17px 140px;
  overflow-y: scroll;
  height: 100%;
`;

export const CombinationValue = styled.div<CombinationValueType>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  border-radius: 3px;
  min-width: 127px;
  font-weight: 400;
  line-height: 16px;
  padding: ${({ isCustom }) => isCustom ? '10px 20px 10px 15px' : '10px 15px'};
  align-items: ${({ alignItems }) => alignItems};
  font-size: 16px;
  background: ${({ hilightDimension }) => hilightDimension ? `${hilightDimension}50` : '#fff'};
  border: 1px solid ${({ hilightDimension }) => hilightDimension ? `${hilightDimension}` : '#979797'};
  opacity: ${({ isBeingDeleted }) => isBeingDeleted ? .4 : 1};
`;

export const CardinalityValue = styled(CombinationValue)`
  padding: 5px 10px 4px;
  align-items: center;
  font-size: 12px;
  background: ${({ hilightDimension }) => hilightDimension ? `${hilightDimension}50` : '#E9F3FD'};
  border: none;
`;

export const CombinationText = styled.p`
  position: absolute;
  top: 4px;
  right: 4px;
  margin: 0;
  line-height: 0.4;
  cursor: pointer;

  &:hover {
    ${CombinationValue} {
      border-color: #FF6961;
      color: #FF6961;
    }
  }
`;


export const CombinationWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  margin-right: 17px;
`;

export const CombinationListWrapper = styled.div<CustomCss>`
  display: flex;
  padding: 10px 0;
  flex-wrap: wrap;
  row-gap: 10px;

  ${({ customCss }) => customCss}
`;

export const DimensionTitle = styled.p<DimensionTitleType>`
  display: inline-block;
  font-size: 17px;
  line-height: 22px;
  font-weight: ${({ isPopup }) => isPopup ? 700 : 600};
  color: ${({ isPopup }) => isPopup ? '#4A4A4A' : '#000'};
  margin-right: 10px;
  min-width: max-content;
`;

export const ScanTitle = styled.p`
  display: inline-block;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #4A4A4A;
`;

export const AllDimensionList = styled.ul`
  list-style-type: none;

  & li {
    position: relative;
    padding-left: 51px;
  }

  & li::before {
    content: "";
    position: absolute;
    left: 21px;
    top: 0px;
    border-bottom: 2px dashed #979797;
    border-radius: 0 0 0 16px;
    width: 41px;
    height: 13px;
  }

  & li::after {
    content: "";
    position: absolute;
    left: 21px;
    bottom: -12px;
    border-left: 2px dashed #979797;
    width: 0;
    height: 105%;
  }

  & li:last-child::after {
    display: none;
  }

  & li:last-child::before {
    border-left: 2px dashed #979797;
  }
`;

export const PointerIconRing = styled.div<PointerIcon>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ margin }) => margin};
  width: 24px;
  height: 24px;
  background: ${({ isSubPointer }) => !isSubPointer && '#979797'};
  border-radius: ${({ isSubPointer }) => !isSubPointer && '50%'};

  > svg {
    width: 24px;
    height: 24px;
    fill: #979797;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`;

export const dimensionCustomCss = css`
  &:before {
    content: "";
    position: relative;
    top: 36px;
    left: -32px;
    height: 58px;
    border-left: 2px dashed #979797;
  }
`;

export const AddDimensionBtn = styled.span`
  display: grid;
  place-content: center;
  min-width: 32px;
  height: 34px;
  border: 1px solid #0046FF;
  border-radius: 5px;
  margin: 10px 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #0046FF;
  cursor: pointer;
`;

export const AddDimensionWrapper = styled.div`
  position: absolute;
  left: 30px;
`;

export const DimensionWrapper = styled.div<{ displayAddDimension: boolean }>`
  position: relative;
  padding-left: ${({ displayAddDimension }) => displayAddDimension ? 94 : 36}px;
  min-height: 90px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 23px 20px;
`;

export const ConfigHeaderText = styled.p`
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
`;

export const AddPopupWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 32px 20px 22px;
  background-color: #fff;
  border: 1px solid #D9D9D9;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
`;

export const SelectWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  margin: 8px 0;
`;

export const PrimaryBtn = styled.button`
  background: #266FFF;
  border-radius: 5px;
  border: 1px solid #266FFF;
  padding: 6px 11px;
  color: #FFF;

  &:disabled {
    opacity: 0.4;
  }
`;

export const StyledSelect = styled(Select)`
  width: 200px;
`;

export const StyledSpace = styled(Space)`
  font-size: 18px;
  cursor: pointer;
  height: 12px;
`;
